import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { FrameContainer } from '../styledComponents/layout'
import { DownloadButtonWrapper } from '../styledComponents/theme'

const HeadImage = styled.img`
width: 90%;
max-width: 400px;
margin:30px auto 10px;
display:block;
`;
const Image = styled.img`
width: 100%;
max-width: 800px;
margin: 10px auto;
display: block;
`;
const Section = styled.section`
display:flex;
flex-direction: column;
justify-content: center;
text-align: center;
`;
const MainVisualWrapper = styled.div`
width: 100%;
background-image: url("/about/img/main_background.jpg");
vertical-align: bottom;
`;
const SystemWrapper = styled.div`
background-color: #d8000b;
`;
const ContentsChannelWrapper = styled.div`
background-color: #6cb545;
`;
const Paragraph = styled.p`
font-size: 1.4rem;
line-height: 2.8rem;
display:block;

`;

const AboutPage = (props) => {
  return(
    <Section className="about">
      <MainVisualWrapper>
        <Image src="/about/img/main.png" alt="ファンの観たいをファンとつくる番組メディア Flick!On!TV （無料）"/>
      </MainVisualWrapper>
      <FrameContainer>
        <h1><HeadImage src="/about/img/catch.png" alt="フリックオンTVとは？"/></h1>
        <Paragraph><strong> 『ファンの観たいをファンとつくる番組メディア』</strong></Paragraph>
        <Paragraph>
          Flick!On!TV（フリックオンTV）は、毎日無料でもらえるF!P（フリックポイント）を番組にフリックオン（＝応援）することで、番組や出演者を応援できる新感覚スマホメディアアプリです。
        </Paragraph>
        <Image src="/about/img/crowd.png" alt="特長イメージ"/>
        <h2><HeadImage src="/about/img/head_video.png" alt="30秒でわかるFlick!On!TV動画" id="imgsrc17023437_1" className=" c-no_adjust"/></h2>
        <a href="https://www.youtube.com/watch?v=-hOoKpi9C8Y" target="_blank">
          <Image src="/about/img/youtube.jpg" alt="YouTubeで観る" id="imgsrc17023435_1" className=" c-no_adjust"/>
        </a>
        <hr/>
        <h2><HeadImage src="/about/img/tokucho.png" alt="Flick!On!TVの特長" id="imgsrc17023357_1" className=" c-no_adjust"/></h2>
        <Paragraph><strong>すべて、オリジナル番組！</strong><br/>劇場やメディアで活躍中の、実力あるよしもと若手芸人などが出演します。</Paragraph>

        <HeadImage src="/about/img/ttl.png" alt="みんなで番組やタレントを応援しよう！ 続編配信はあなたの応援次第！" id="imgsrc17023361_1" className=" c-no_adjust" />
        <Paragraph><strong>フリックオンされたF!P（フリックポイント）が目標ポイント数に到達すると続編の配信が決定！</strong></Paragraph>
        <Paragraph>毎日無料でもらえるアプリ内仮想ポイント『F!P（フリックポイント）』を、お気に入りの番組にフリックオン（＝応援）しましょう！</Paragraph>
        <SystemWrapper>
          <Image src="/about/img/system.png" alt="STEP1 F!P（フリックポイント）を使って、お気に入り番組をみんなで応援！ STEP2 目標ポイント達成で、続編の配信が決定！" id="imgsrc17023363_1"/>
        </SystemWrapper>
        <hr/>
        <ContentsChannelWrapper>
          <Image src="/about/img/contents_channel.png" alt="コンテンツチャンネル　あなたが番組を気に入ったり、続編を観たいと思ったら、F!P（フリックポイント）で応援しよう！" id="imgsrc17023365_1"/>
        </ContentsChannelWrapper>
        <Paragraph>Flick!On!TVオリジナル番組を視聴できるチャンネルです。番組を気に入ったり、続編を見たいと思ったら、F!P（フリックポイント）で応援しましょう。目標ポイントに到達すると続編の配信が決定します！</Paragraph>
        <h2><HeadImage src="/about/img/app_download.png" alt="アプリダウンロード（無料）はこちら！"/></h2>
        <DownloadButtonWrapper>
          <a
            href={props.data.site.siteMetadata.firebaseDynamicLink}>
            <img src="/img/app_download.png" alt="アプリダウンロード"/>
          </a>
        </DownloadButtonWrapper>
      </FrameContainer>
    </Section>
  );
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about.js